//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ContentLibraryHelper', [
    function() {
      const self = this;

      self.contentItemConcat = function(sourceArray, additionalArray) {
        const newItems = _(additionalArray).reject((item) => {
          return _(sourceArray).findWhere({ id: item.id });
        });
        return sourceArray.concat(newItems);
      };
    },
  ]);
})();
